module.exports = __webpack_public_path__ + "img/dash.e4198715.png";